import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";



// Moving "सतर्कता समिति" to its correct list
const updatedPrakoshtha = [
    { name: "आंतरिक गुणवत्ता आश्वासन प्रकोष्ठ (IQAC Cell)" },
    { name: "सूचना का अधिकार प्रकोष्ठ (RTI Cell)" },
    { name: "प्लेसमेंट प्रकोष्ठ (Placement Cell)" },
    { name: "आंतरिक शिकायत समिति एवं महिला प्रकोष्ठ (Internal Complaint Committee & Women Cell)" },
    { name: "रैगिंग निषेध प्रकोष्ठ (Anti-Ragging Cell)" },
    { name: "मार्गदर्शन एवं परामर्श प्रकोष्ठ (Guidance & Counselling Cell)" },
    { name: "अनुसूचित जाति / जनजाति प्रकोष्ठ (SC/ST Cell)" },
    { name: "सतर्कता प्रकोष्ठ (Vigilance Cell)" },
    { name: "सूचना प्रौद्योगिकी प्रकोष्ठ (I.T. Cell)" },
    { name: "जनसंपर्क अधिकारी (PRO Cell)" },
    { name: "राष्ट्रीय अकादमिक डिपॉजिटरी प्रकोष्ठ (NAD Cell)" },
    { name: "राष्ट्रीय शिक्षा नीति प्रकोष्ठ (NEP Cell)" }
];

const updatedSamiti = [

    { name: "प्रवेश समिति (Admission Committee)", link: "#" },
    { name: "समय-सारणी समिति (Time Table Committee)", link: "#" },
    { name: "अनुचित साधन समिति (Unfair Means Committee)", link: "#" },
    { name: "शोध एवं प्रकाशन समिति (Research & Publication Committee)", link: "#" },
    { name: "सांस्कृतिक समिति (Cultural Committee)", link: "#" },
    { name: "छात्रवृत्ति समिति (Scholarship Committee)", link: "#" },
    { name: "पुस्तकालय समिति (Library Committee)", link: "#" },
    { name: "इंटर्नशिप समिति (Internship Committee)", link: "#" },
    { name: "खेल और क्रीड़ा समिति (Sports & Games Committee)", link: "#" },
    { name: "समझौता ज्ञापन समिति (MOU Committee)", link: "#" },
    { name: "अनुशासन समिति (Discipline Committee)", link: "#" },
    { name: "छात्रावास समिति (Hostel Committee)", link: "#" },
    { name: "शिक्षक एवं अभिभावक संवाद समिति (Teacher & Guardian Interaction Committee)", link: "#" },
    { name: "छात्र कल्याण समिति (Student Welfare Committee)", link: "#" },
    { name: "राष्ट्रीय कैडेट कोर और राष्ट्रीय सेवा योजना समिति (NCC & NSS Committee)", link: "#" },


];


const allDepartments = [...updatedPrakoshtha, ...updatedSamiti];


const iqacMembers = [
    { id: 1, name: "निदेशक, आंतरिक गुणवत्ता आश्वासन प्रकोष्ठ, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "अधिष्ठाता शैक्षणिक, म.वा.सं.वि., कैथल", role: "सदस्य" },
    { id: 3, name: "साहित्य संकाय अधिष्ठाता, म.वा.सं.वि., कैथल", role: "सदस्य" },
    { id: 4, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 5, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 6, name: "डॉ. नवीन शर्मा, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 7, name: "डॉ. चन्द्रकान्त, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 8, name: "डॉ. गोविन्द वल्लभ, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 9, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 10, name: "श्री अमरदीप, डी.ई.ओ. (HKRN), म.वा.सं.वि., कैथल", role: "सदस्य" },
];



// सूचना का अधिकार प्रकोष्ठ (RTI) के सदस्य डेटा
const rtiMembers = [
    { id: 1, name: "कुलसचिव, म.वा.सं.वि., कैथल", role: "प्रथम अपीलीय प्राधिकारी" },
    { id: 2, name: "अधीक्षक (वित्त), म.वा.सं.वि., कैथल", role: "राज्य लोक सूचना अधिकारी" },
    { id: 3, name: "श्री अंकुर, डी.ई.ओ. (HKRN), म.वा.सं.वि., कैथल", role: "सहायक लोक सूचना अधिकारी" },
];

// प्लेसमेंट प्रकोष्ठ के सदस्य डेटा
const placementMembers = [
    { id: 1, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "श्री मुकेश कुमार, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "सदस्य" }
];

const internalComplaintCommitteeMembers = [
    { id: 1, name: "डॉ. शर्मिला, म.वा.सं.वि., कैथल", role: "अध्यक्ष" },
    { id: 2, name: "डॉ. जगत नारायण कौशिक, म.वा.सं.वि., कैथल", role: "सह-अध्यक्ष" },
    { id: 3, name: "प्रो॰ (डॉ॰) रोज़ी गुप्ता, डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल", role: "सदस्य" },
    { id: 4, name: "श्री सुभाष चन्द, अधीक्षक, म.वा.सं.वि., कैथल", role: "सदस्य" },
    { id: 5, name: "सुश्री संदीपी, सहायक प्राध्यापक (कंप्यूटर विज्ञान), डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल", role: "सदस्य" },
    { id: 6, name: "सुश्री नीलम, शोधार्थी (साहित्य विभाग)", role: "सदस्य" },
    { id: 7, name: "सुश्री कुसुम, छात्र, आचार्य- प्रथम वर्ष", role: "सदस्य" },
    { id: 8, name: "श्रीमती अनिता, डी. ई. ओ. (HKRN)", role: "सदस्य" }
];

// असुविधा समाधान एवं शिकायत प्रकोष्ठ के सदस्य डेटा
const grievanceMembers = [
    { id: 1, name: "डॉ. शर्मिला, सहायक आचार्या, म.वा.सं.वि., कैथल ।", role: "अध्यक्ष" },
    { id: 2, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "प्रो. (डॉ.) रोजी गुप्ता, डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल ।", role: "सदस्य" },
    { id: 4, name: "श्री सुभाष चन्द, अधीक्षक (प्रशासन), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "सुश्री संदीपी, सहायक आचार्या (कम्प्यूटर साईस), डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल ।", role: "सदस्य" },
    { id: 6, name: "सुश्री नीलम, शोधार्थी (साहित्य विभाग)", role: "सदस्य" },
    { id: 7, name: "सुश्री कुसुम, छात्रा (आचार्य- प्रथम वर्ष)", role: "सदस्य" },
    { id: 8, name: "श्रीमती अनीता, डी.E.ओ. (HKRN), म.वा.सं.वि., कैथल ।", role: "सदस्य" }
];

// शिस्तबद्धता समिति के सदस्य डेटा
const disciplineCommitteeMembers = [
    { id: 1, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य, म.वा.सं.वि., कैथल ।", role: "अध्यक्ष" },
    { id: 2, name: "डॉ. शर्मिला, सहायक आचार्या, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "श्री तरसेम, डी.E.ओ. (HKRN), म.वा.सं.वि., कैथल ।", role: "सदस्य" }
];

// एंटी रैगिंग प्रकोष्ठ के सदस्य डेटा
const antiRaggingMembers = [
    { id: 1, name: "पर्यवेक्षक", role: "संयोजक" },
    { id: 2, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. शर्मिला, सहायक आचार्य (वार्डन छात्रा छात्रावास), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध) (वार्डन छात्र छात्रावास), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" }
];


const SCSTCellMembers = [
    { id: 1, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य, म.वा.सं.वि., कैथल", role: "सदस्य" },
    { id: 3, name: "सुश्री संदीपी, सहायक प्राध्यापक (कंप्यूटर विज्ञान), डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल", role: "सदस्य" },
    { id: 4, name: "सुश्री परमिंदर कौर, सहायक प्राध्यापक (कंप्यूटर विज्ञान), डॉ. बी.आर. अम्बेडकर राजकीय महाविद्यालय, कैथल", role: "सदस्य" },
    { id: 5, name: "श्री विकास कटारिया, सहायक, म.वा.सं.वि., कैथल", role: "सदस्य" },
];
// जनसंपर्क अधिकारी (PRO) के सदस्य डेटा
const proMembers = [
    { id: 1, name: "डॉ. गोविन्द बल्लभ, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "जनसंपर्क अधिकारी" },
    { id: 2, name: "श्री मुकेश कुमार, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "" }
];

// प्रवेश समिति के सदस्य डेटा
const registrationCommittee = [
    { id: 1, name: "अधिष्ठाता शैक्षणिक, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य", role: "सह-संयोजक" },
    { id: 3, name: "डॉ. सुरेन्द्र पाल वत्स, सह-आचार्य", role: "सदस्य" },
    { id: 4, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 5, name: "डॉ. नरेश शर्मा, सहायक आचार्य", role: "सदस्य" },
    { id: 6, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 7, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य", role: "सदस्य" },
    { id: 8, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 9, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 10, name: "डॉ. कुलदीप सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 11, name: "श्री प्रवीन कुमार, सहायक", role: "" },
    { id: 12, name: "श्री रमेश, लिपिक (HKRN)", role: "" },
    { id: 13, name: "श्री साहिल, शुल्क लिपिक (HKRN)", role: "" }
];


// समय सारणी समिति के सदस्य डेटा
const TimetableCommittee = [
    { id: 1, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य", role: "संयोजक" },
    { id: 2, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 3, name: "डॉ. शर्मिला, सहायक आचार्य", role: "सदस्य" },
    { id: 4, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 5, name: "डॉ. चन्द्रकान्त, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 6, name: "श्री सीता राम, लिपिक (HKRN)", role: "" }
];


// अनुचित साधन समिति के सदस्य डेटा
const UnfairCommittee = [
    { id: 1, name: "परीक्षा नियंत्रक, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "डॉ. सुरेन्द्र पाल वत्स, सह-आचार्य", role: "सदस्य" },
    { id: 3, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 4, name: "विषय विशेषज्ञ", role: "सदस्य" }
];


// सांस्कृतिक समिति के सदस्य डेटा
const CulturalCommittee = [
    { id: 1, name: "डॉ. शर्मिला, सहायक आचार्य", role: "संयोजक" },
    { id: 2, name: "डॉ. नवीन शर्मा, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 3, name: "डॉ. हरीश कुमार, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 4, name: "डॉ. राजीव शर्मा, सहायक आचार्य (अंशकालिक)", role: "सदस्य" },
    { id: 5, name: "डॉ. महावीर, लिपिक (HKRN)", role: "" }
];



const ResearchPublicationCommittee = [
    { id: 1, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य", role: "संयोजक" },
    { id: 2, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य", role: "सह-संयोजक" },
    { id: 3, name: "डॉ. नवीन शर्मा, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 4, name: "डॉ. चन्द्रकान्त, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 5, name: "श्री मुकेश कुमार, लिपिक (HKRN)", role: "" }
];


// छात्रवृत्ति समिति के सदस्य डेटा
const ScholarshipCommittee = [
    { id: 1, name: "डॉ. सुरेन्द्र पाल वत्स, सह-आचार्य", role: "संयोजक" },
    { id: 2, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य", role: "सदस्य" },
    { id: 3, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य", role: "सदस्य" },
    { id: 4, name: "श्री सिकन्दर लाल, डी. ई. ओ. (HKRN)", role: "" }
];

const InternshipCommittee = [
    { id: 1, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य", role: "संयोजक" },
    { id: 2, name: "डॉ. नवीन शर्मा, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 3, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 4, name: "डॉ. कुलदीप सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 5, name: "डॉ. हरीश कुमार, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 6, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" }
];

const ITCell = [
    { id: 1, name: "डॉ. चन्द्रकांत, सहायक आचार्य (अनुबन्ध)", role: "संयोजक" },
    { id: 2, name: "डॉ. गोविन्द वल्लभ, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 3, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 4, name: "श्री संजीव कुमार, अधीक्षक (प्रतिनियुक्ति)", role: "सदस्य" },
    { id: 5, name: "श्री अंकुर गुप्ता, अधीक्षक (प्रतिनियुक्ति)", role: "सदस्य" },
    { id: 6, name: "श्री मुकेश कुमार, लिपिक (HKRN)", role: "सामग्री निर्माण" },
    { id: 7, name: "श्री अंकुर, डी. ई. ओ. (HKRN)", role: "" },
    { id: 8, name: "श्रीमती अनिता, डी. ई. ओ. (HKRN)", role: "" }
];
const NADCell = [
    { id: 1, name: "डॉ. चन्द्र कान्त, सहायक आचार्य (अनुबन्ध)", role: "नोडल अधिकारी" },
    { id: 2, name: "श्री राकेश कुमार, डी. ई. ओ. (HKRN)", role: "सदस्य" }
];

const NEPCell = [
    { id: 1, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य", role: "समन्वयक" },
    { id: 2, name: "", role: "" }
];

// पुस्तकालय समिति के सदस्य डेटा
const LibraryCommittee = [
    { id: 1, name: "अधिष्ठाता शैक्षणिक, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य (विभागाध्यक्ष, साहित्य)", role: "सदस्य" },
    { id: 3, name: "डॉ. सुरेन्द्र पाल वत्स, सह-आचार्य (विभागाध्यक्ष, व्याकरण)", role: "सदस्य" },
    { id: 4, name: "डॉ. नरेश शर्मा, सहायक आचार्य (विभागाध्यक्ष, ज्योतिष)", role: "सदस्य" },
    { id: 5, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य (विभागाध्यक्ष, वेद)", role: "सदस्य" },
    { id: 6, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य (विभागाध्यक्ष, हिंदू अध्ययन)", role: "सदस्य" },
    { id: 7, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध) (प्रभारी - योग)", role: "सदस्य" },
    { id: 8, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध) (प्रभारी - दर्शन)", role: "सदस्य" },
    { id: 9, name: "डॉ. कुलदीप सिंह, सहायक आचार्य (अनुबन्ध) (प्रभारी - धर्मशास्त्र)", role: "सदस्य" },
    { id: 10, name: "श्री कुलवन्त सिंह, लिपिक (HKRN)", role: "सदस्य" }
];


// खेल और क्रीड़ा समिति के सदस्य डेटा
const GamesAndSportsCommittee = [
    { id: 1, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध)", role: "संयोजक" },
    { id: 2, name: "डॉ. कुलदीप सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 3, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध)", role: "सदस्य" },
    { id: 4, name: "श्री सिकन्दर लाल, डी. ई. ओ. (HKRN)", role: "" }
];

// समझौता ज्ञापन समिति के सदस्य डेटा
const MOUMemoraCommittee = [
    { id: 1, name: "डॉ. सुरेन्द्र पाल वत्स, सह-आचार्य, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सह-संयोजक" },
    { id: 3, name: "डॉ. हरीश कुमार, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. महावीर, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "" }
];

// अनुशासन समिति के सदस्य डेटा (Note: This was a duplicate of Shistabaddhta Samiti in original, keeping distinct now)
const DisciplineCommittee = [
    { id: 1, name: "डॉ. जगत नारायण कौशिक, सह-आचार्य, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. शर्मिला, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "श्री तरसेम कुमार, डी. ई. ओ. (HKRN), म.वा.सं.वि., कैथल ।", role: "" },
];


// छात्रावास समिति के सदस्य डेटा
const HostelCommittee = [
    { id: 1, name: "अधिष्ठाता शैक्षणिक, म.वा.सं.वि., कैथल ।", role: "अध्यक्ष" },
    { id: 2, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य (मुख्य वार्डन), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. शर्मिला, सहायक आचार्य (वार्डन छात्रा छात्रावास), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध) (वार्डन छात्र छात्रावास), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "श्री रमेश, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "" },
];


// शिक्षक एवं अभिभावक संपर्क समिति के सदस्य डेटा
const TeacherGuardianInteractionCommittee = [
    { id: 1, name: "डॉ. कृष्ण चन्द्र पाण्डेय, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. हरीश कुमार, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. देवेन्द्र सिंह, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. गोविन्द वल्लभ, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
];


// छात्र कल्याण समिति के सदस्य डेटा
const StudentWelfareCell = [
    { id: 1, name: "छात्र कल्याण अधिष्ठाता, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. नरेश शर्मा, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. शर्मिला, सहायक आचार्या, म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "डॉ. चन्द्रकान्त, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 6, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 7, name: "श्री रमेश, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
];


// एन. सी.सी. व एन. एस. एस. समिति के सदस्य डेटा    
const NCCAndNSSCommittee = [
    { id: 1, name: "डॉ. नरेश शर्मा, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "समन्वयक (राष्ट्रीय सेवा योजना)" },
    { id: 2, name: "डॉ. विनय गोपाल त्रिपाठी, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "समन्वयक (राष्ट्रीय कैडेट कोर)" },
    { id: 3, name: "डॉ. चन्द्रकान्त, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. गोविन्द वल्लभ, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 5, name: "श्री सीता राम, लिपिक (HKRN), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
];


// सतर्कता समिति के सदस्य डेटा
const VigilanceCell = [
    { id: 1, name: "वित्त अधिकारी, म.वा.सं.वि., कैथल", role: "संयोजक" },
    { id: 2, name: "उपकुलसचिव, म.वा.सं.वि., कैथल", role: "सदस्य" },
    { id: 3, name: "डॉ. अखिलेश कुमार मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल", role: "सदस्य" },
];

// मार्गदर्शन एवं परामर्श प्रकोष्ठ के सदस्य डेटा
const GuidanceAndCounsellingCell = [
    { id: 1, name: "डॉ. रामानन्द मिश्र, सहायक आचार्य, म.वा.सं.वि., कैथल ।", role: "संयोजक" },
    { id: 2, name: "डॉ. नवीन शर्मा, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 3, name: "डॉ. हरीश कुमार, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
    { id: 4, name: "डॉ. गोविन्द वल्लभ, सहायक आचार्य (अनुबन्ध), म.वा.सं.वि., कैथल ।", role: "सदस्य" },
];

// Mapping of department/committee names to their respective member data
const membersMap = {
    "आंतरिक गुणवत्ता आश्वासन प्रकोष्ठ (IQAC Cell)": iqacMembers,
    "सूचना का अधिकार प्रकोष्ठ (RTI Cell)": rtiMembers,
    "प्लेसमेंट प्रकोष्ठ (Placement Cell)": placementMembers,
    "आंतरिक शिकायत समिति एवं महिला प्रकोष्ठ (Internal Complaint Committee & Women Cell)": internalComplaintCommitteeMembers,
    "असुविधा समाधान एवं शिकायत प्रकोष्ठ": grievanceMembers,
    "शिस्तबद्धता समिति": disciplineCommitteeMembers,
    "रैगिंग निषेध प्रकोष्ठ (Anti-Ragging Cell)": antiRaggingMembers,
    "जनसंपर्क अधिकारी (PRO Cell)": proMembers,
    "प्रवेश समिति (Admission Committee)": registrationCommittee,
    "समय-सारणी समिति (Time Table Committee)": TimetableCommittee,
    "अनुचित साधन समिति (Unfair Means Committee)": UnfairCommittee,
    "शोध एवं प्रकाशन समिति (Research & Publication Committee)": ResearchPublicationCommittee,
    "सांस्कृतिक समिति (Cultural Committee)": CulturalCommittee,
    "छात्रवृत्ति समिति (Scholarship Committee)": ScholarshipCommittee,
    "इंटर्नशिप समिति (Internship Committee)": InternshipCommittee,
    "पुस्तकालय समिति (Library Committee)": LibraryCommittee,
    "खेल और क्रीड़ा समिति (Sports & Games Committee)": GamesAndSportsCommittee,
    "समझौता ज्ञापन समिति (MOU Committee)": MOUMemoraCommittee,
    "अनुशासन समिति (Discipline Committee)": DisciplineCommittee,
    "छात्रावास समिति (Hostel Committee)": HostelCommittee,
    "शिक्षक एवं अभिभावक संवाद समिति (Teacher & Guardian Interaction Committee)": TeacherGuardianInteractionCommittee,
    "छात्र कल्याण समिति (Student Welfare Committee)": StudentWelfareCell,
    "राष्ट्रीय कैडेट कोर और राष्ट्रीय सेवा योजना समिति (NCC & NSS Committee)": NCCAndNSSCommittee,
    "सतर्कता प्रकोष्ठ (Vigilance Cell)": VigilanceCell,
    "मार्गदर्शन एवं परामर्श प्रकोष्ठ (Guidance & Counselling Cell)": GuidanceAndCounsellingCell,
    "अनुसूचित जाति / जनजाति प्रकोष्ठ (SC/ST Cell)": SCSTCellMembers,
    "सूचना प्रौद्योगिकी प्रकोष्ठ (I.T. Cell)": ITCell,
    "राष्ट्रीय अकादमिक डिपॉजिटरी प्रकोष्ठ (NAD Cell)": NADCell,
    "राष्ट्रीय शिक्षा नीति प्रकोष्ठ (NEP Cell)": NEPCell

};

export default function SpecialCellsCommittees() {

    const [showSidebar, setShowSidebar] = useState(window.innerWidth >= 768);

    // Initial content set to the first item in the *updated* prakoshtha list
    const [content, setContent] = useState(updatedPrakoshtha[0].name);

    // Restored the collapsible states
    const [showPrakoshtha, setShowPrakoshtha] = useState(true);
    const [showSamiti, setShowSamiti] = useState(true);


    useEffect(() => {
        const handleResize = () => {
            setShowSidebar(window.innerWidth >= 768);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleItemClick = (deptName) => {
        setContent(deptName);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };


    const membersToDisplay = membersMap[content];

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">

            <div className="d-md-none sticky-top bg-primary p-2 shadow-sm d-flex justify-content-between align-items-center">
                <button
                    className="btn d-md-none m-2 shadow-sm text-white"
                    onClick={() => setShowSidebar(!showSidebar)}
                    style={{
                        backgroundColor: "#77236b",
                        borderColor: "#77236b"
                    }}
                >
                    ☰ मेनू
                </button>


                <h5 className="text-white my-0">विशेष प्रकोष्ठ एवं समितियां</h5>
            </div>


            <aside
                className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"
                    } col-md-3 bg-white`}
                style={{ overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 d-none d-md-block text-dark">विशेष प्रकोष्ठ एवं समितियां</h5>
                <div className="flex-grow-1">

                    {/* Prakoshtha Section - Collapsible */}
                    <div className="card mt-3">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => setShowPrakoshtha(!showPrakoshtha)}
                            style={{ cursor: "pointer", backgroundColor: '#77236b', color: '#fff', fontWeight: 'bold' }}
                        >
                            प्रकोष्ठ
                            <span className="fs-5">
                                {showPrakoshtha ? '−' : '+'}
                            </span>
                        </div>
                        <div className={`collapse ${showPrakoshtha ? 'show' : ''}`} id="prakoshthaCollapse">
                            <div className="card-body p-0">
                                {updatedPrakoshtha.map((dept, index) => (
                                    <p
                                        key={`prakoshtha-${index}`}
                                        className={`mb-0 p-3 border-bottom rounded-0 ${content === dept.name
                                            ? "text-white"
                                            : "text-dark"
                                            }`}
                                        onClick={() => handleItemClick(dept.name)}
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "0.95rem",
                                            backgroundColor: content === dept.name ? "#77236b" : "#f8f9fa"
                                        }}
                                    >
                                        {dept.name}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>


                    {/* Samiti Section - Collapsible */}
                    <div className="card mt-3">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => setShowSamiti(!showSamiti)}
                            style={{ cursor: "pointer", backgroundColor: '#77236b', color: '#fff', fontWeight: 'bold' }}
                        >
                            समितियां
                            <span className="fs-5">
                                {showSamiti ? '−' : '+'}
                            </span>
                        </div>
                        <div className={`collapse ${showSamiti ? 'show' : ''}`} id="samitiCollapse">
                            <div className="card-body p-0">
                                {updatedSamiti.map((dept, index) => (
                                    <p
                                        key={`samiti-${index}`}
                                        className={`mb-0 p-3 border-bottom rounded-0 ${content === dept.name
                                            ? "text-white"
                                            : "text-dark"
                                            }`}
                                        onClick={() => handleItemClick(dept.name)}
                                        style={{
                                            cursor: "pointer",
                                            fontSize: "0.95rem",
                                            backgroundColor: content === dept.name ? "#77236b" : "#f8f9fa"
                                        }}
                                    >
                                        {dept.name}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </aside>


            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 d-flex flex-column"
                style={{ overflowY: 'auto' }}
            >
                {content ? (
                    <>
                        {membersToDisplay && membersToDisplay.length > 0 ? (
                            <div className="table-responsive flex-grow-1">
                                <h6 className="mb-3 text-center fw-bold" style={{ color: "#77236b" }}>
                                    {`${content} के सदस्य`}
                                </h6>
                                <table className="table table-bordered table-striped table-hover mt-3">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>क्रमांक</th>
                                            <th>नाम</th>
                                            <th>पद</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {membersToDisplay.map((member) => (
                                            <tr key={member.id}>
                                                <td>{member.id}</td>
                                                <td>{member.name}</td>
                                                <td>{member.role}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p className="text-center mt-5 fs-5 text-muted">इस अनुभाग के लिए कोई सदस्य डेटा उपलब्ध नहीं है।</p>
                        )}
                    </>
                ) : (
                    <p className="text-center mt-5 fs-5 text-muted">कृपया बाईं ओर मेनू से एक अनुभाग चुनें।</p>
                )}
            </main>
        </div>
    );
}